import FrameBorder from '@/component/FrameBorder';
import Tables from '@/component/Tables';
import { getShweVaultHistory } from '@/Redux/futures/ShweVault/actions';
import backgroundImg from '@assets/web-v3-images/FrameBorder.png';
import { Table, Text } from '@radix-ui/themes';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { NoData } from './NoData';
import { formatHistoryDate } from '../formatDate';
import { formatDataNumberToen } from '@/utils/helper';
import { useNavigate } from 'react-router';
import PATH from '@/config/PATH';

export default function LPhistory() {
	const { t } = useTranslation();
	const dispatch = useDispatch();
	const navigate = useNavigate()
	const [page, setPage] = useState(1);
	const [dataResApi, setdataResApi] = useState(null)

	const afterShweVaultHistory = (data, isLoading) => {
		if (data) {
			setdataResApi(data)
		}
	}

	const getShweVaultPage = () => {
		const body = {
			query: {
				limit: 11,
				page: page,
			},
			callback: afterShweVaultHistory
		}
		dispatch(getShweVaultHistory(body))
	}

	useEffect(() => {
		getShweVaultPage()
	}, [page]);

	const columns = [
		{ key: "source", title: t("history.source") },
		{ key: "amount", title: t("history.amount") },
	];

	if (dataResApi && (dataResApi.data?.length ?? 0) === 0) {
		return (
			<div className='pt-[25%] px-10'>
				<NoData
					title={t("history.no_transactions")}
					describe={t("history.your_LP_transaction_history_will_appear_here")}
					textBtn={t("history.get_LP")}
					handleClick={() => navigate(PATH.LOYALTY_POINT)}
				/>
			</div>
		)
	}

	return (
		<div className='mt-3 min-h-0 flex flex-col'>
			<FrameBorder fill>
				<div
					className="w-full bg-cover bg-no-repeat min-h-0 flex flex-col"
					style={{
						backgroundImage: `url(${backgroundImg})`,
					}}
				>
					<div className='mx-[8px] sm:mx-[30px] py-4 min-h-0 flex flex-col'>
						<Tables
							fill
							current={page}
							stickyHeader
							onChange={(p) => setPage(p)}
							columns={columns}
							pagination={true}
							data={dataResApi?.data || []}
							totalPages={Math.ceil((dataResApi?.total || 0) / Number(dataResApi?.limit || 1))}
							renderRow={(item) => (
								<Table.Row key={item.key}>
									<Table.Cell>
										<div className="flex items-center h-full text-left gap-1">
											<div className="flex flex-col w-[350px] shrink-0">
												<Text className="font-semibold text-[rgba(113,59,18,1)]">{item.source_label}</Text>
												<Text className="font-medium text-[rgba(161,92,7,1))] text-[19px] italic">
													{formatHistoryDate(item?.transaction_time)}
												</Text>
												{/* "Expires <ngày hết hạn>" xuống dòng riêng dưới ngày giao dịch */}
												{item?.transaction_type === 'EARN' && (
													<Text className="font-medium text-[rgba(161,92,7,1))] text-[19px] italic">
														{t('loyalty_point.expires')} {formatHistoryDate(item?.batch_expire_time)}
													</Text>
												)}
											</div>
										</div>
									</Table.Cell>
									<Table.Cell>
										<div className="flex items-center h-full text-left gap-1">
											<div className="flex flex-col w-[280px] shrink-0">
												<Text className='flex items-center h-full text-left font-semibold text-[rgba(113,59,18,1)]'>
													{item?.transaction_type === 'EARN' ? "+" : "-"}	{formatDataNumberToen(item.amount)} LP
												</Text>
												<Text className="font-medium text-[rgba(161,92,7,1))] text-[19px] italic">
													{t('loyalty_point.balance')} {formatDataNumberToen(item?.balance_after || 0)}
												</Text>
											</div>
										</div>
									</Table.Cell>
								</Table.Row>
							)}
						/>
					</div>
				</div>
			</FrameBorder>
		</div>
	)
}
